import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

import { CommonModule } from "@angular/common";
import { socialLink } from "@constants";
import { SvgIconComponent } from "./svg-icon/svg-icon.component";

interface SocialIcon {
  icon: string;
  link: string;
}

@Component({
  selector: "app-social-icons",
  standalone: true,
  imports: [SvgIconComponent, CommonModule],
  templateUrl: "./social-icons.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ["./social-icons.component.scss"],
})
export class SocialIconsComponent {
  @Input() public type: "primary" | "secondary" = "primary";
  @Input() public combination: "a" | "b" | "c" | "e" | "f" = "a";

  public social = socialLink;

  public allIcons: SocialIcon[] = [
    {
      icon: "assets/images/icon-x.svg",
      link: this.social.twitter,
    },
    {
      icon: "assets/images/icon-instagram.svg",
      link: this.social.instagram,
    },
    {
      icon: "assets/images/icon-discord.svg",
      link: this.social.discord,
    },
    {
      icon: "assets/images/icon-youtube.svg",
      link: this.social.youtube,
    },

    {
      icon: "assets/images/icon-telegram.svg",
      link: this.social.telegram,
    },
  ];

  public contactIcons: SocialIcon[] = [
    {
      icon: "discord",
      link: this.social.discord,
    },
    {
      icon: "telegram",
      link: this.social.telegram,
    },
    {
      icon: "instagram",
      link: this.social.instagram,
    },
    {
      icon: "x",
      link: this.social.twitter,
    },
  ];

  public homepageIcons: SocialIcon[] = [
    {
      icon: "discord",
      link: this.social.discord,
    },
    {
      icon: "instagram",
      link: this.social.instagram,
    },
    {
      icon: "x",
      link: this.social.twitter,
    },
    {
      icon: "telegram",
      link: this.social.telegram,
    },
    {
      icon: "facebook",
      link: this.social.facebook,
    },
  ];

  public footerIcons: SocialIcon[] = [
    {
      icon: "x",
      link: this.social.twitter,
    },
    {
      icon: "instagram",
      link: this.social.instagram,
    },
    {
      icon: "discord",
      link: this.social.discord,
    },
    {
      icon: "telegram",
      link: this.social.telegram,
    },
    {
      icon: "facebook",
      link: this.social.facebook,
    },
  ];

  public footerIconsMobile: SocialIcon[] = [
    {
      icon: "discord",
      link: this.social.discord,
    },
    {
      icon: "telegram",
      link: this.social.telegram,
    },
    {
      icon: "instagram",
      link: this.social.instagram,
    },
    {
      icon: "youtube",
      link: this.social.youtube,
    },
    {
      icon: "x",
      link: this.social.twitter,
    },
    {
      icon: "facebook",
      link: this.social.x,
    },
  ];
}
